import { useState } from "react";
import Icon from "../../../designSystem/a-atoms/icons/Icon";
import style from "./Figma.module.css";
import FigmaPreviewDialog from "../components/FigmaPreviewDialog";
import FigmaUrlEditor from "../components/FigmaUrlEditor";
import { isValidFigmaUrl } from "../utils/figmaUtils";

const Figma = (props) => {
  const [showPreview, setShowPreview] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  
  const hasUrl = props.data.value && isValidFigmaUrl(props.data.value);

  function handleClick() {
    if (props.editable) {
      // In edit mode, always open editor (whether URL exists or not)
      setShowEditor(true);
    } else if (hasUrl) {
      // In view mode, open preview if URL exists
      setShowPreview(true);
    }
  }

  function handleClosePreview() {
    setShowPreview(false);
  }

  function handleCloseEditor() {
    setShowEditor(false);
  }

  function handleSaveUrl(url) {
    setShowEditor(false);
  }

  return (
    <div
      className={`${style.cell} ${props.editable ? style.editable : ""} ${
        hasUrl ? style.hasUrl : ""
      }`}
    >
      {hasUrl ? (
        <button
          type="button"
          className={style.figmaButton}
          onClick={handleClick}
          title={props.editable ? "Edit Figma URL" : "Preview in Figma"}
        >
          <span className={style.figmaLabel}><img src={require("../images/figma.webp")} width="32"  alt="Figma" /></span>
        </button>
      ) : props.editable ? (
        <button
          type="button"
          className={style.addButton}
          onClick={handleClick}
        >
          <Icon>add</Icon>
          <span>Add Figma</span>
        </button>
      ) : null}

      {hasUrl && (
        <FigmaPreviewDialog
          show={showPreview}
          onClose={handleClosePreview}
          figmaUrl={props.data.value}
        />
      )}

      {props.editable && (
        <FigmaUrlEditor
          show={showEditor}
          onClose={handleCloseEditor}
          onSave={handleSaveUrl}
          initialUrl={props.data.value || ""}
          journeyRefURL={props.journeyRefURL}
          rowId={props.row.id}
          cellIndex={props.cellIndex}
        />
      )}
    </div>
  );
};

export default Figma;
